"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BehaviorSubject_1 = require("rxjs/BehaviorSubject");
class JsonGraphSubject extends BehaviorSubject_1.BehaviorSubject {
    constructor(nodeClass, edgeProperty, store, cacheNodes) {
        super({ nodes: [], edges: [] });
        this.nodeClass = nodeClass;
        this.edgeProperty = edgeProperty;
        this.store = store;
        this.cacheNodes = cacheNodes;
        this.update();
    }
    update() {
        this.store.toJsonGraph(this.nodeClass, this.edgeProperty, this.cacheNodes ? this.getValue() : null)
            .then(graph => this.next(graph));
    }
}
exports.JsonGraphSubject = JsonGraphSubject;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/io/jsongraph.js
// module id = 1306
// module chunks = 3